export interface Denomination {
  label: string;
  value: number;
}

export const BILL_DENOMINATIONS: Denomination[] = [
  { label: '$1',   value: 1 },
  { label: '$2',   value: 2 },
  { label: '$5',   value: 5 },
  { label: '$10',  value: 10 },
  { label: '$20',  value: 20 },
  { label: '$50',  value: 50 },
  { label: '$100', value: 100 },
];

export const COIN_DENOMINATIONS: Denomination[] = [
  { label: '1¢',  value: 0.01 },
  { label: '5¢',  value: 0.05 },
  { label: '10¢', value: 0.10 },
  { label: '25¢', value: 0.25 },
  { label: '50¢', value: 0.50 },
];

export const ROLLED_COIN_DENOMINATIONS: Denomination[] = [
  { label: '1¢ Roll', value: 0.5 },
  { label: '5¢ Roll', value: 2 },
  { label: '10¢ Roll', value: 5 },
  { label: '25¢ Roll', value: 10 },
];

export const DYNATRACE_RUM_SRC = process.env.REACT_APP_DYNATRACE_RUM_URL;
export const TOLERANCE_AMOUNT = process.env.REACT_APP_TOLERANCE_AMOUNT;
